import { Box } from '@mui/material';
import styled from '@mui/system/styled';
import CTypography from 'components/CTypography';

export const ContentCnt = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  flex: 1,
  overflow: 'hidden',
  marginLeft: 12,
});

export const MainCnt = styled('div')({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  overflow: 'hidden',
});

export const ThumbnailCnt = styled('div')({
  borderRadius: 15,
  overflow: 'hidden',
  flexShrink: 0,
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 15,
  },
});

export const Value = styled(CTypography)({
  fontWeight: 600,
  fontSize: '15px',
  lineHeight: '20px',
  color: 'rgba(0,0,0,1)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const SubValue = styled(CTypography)({
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '16px',
  color: '#6b7280',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const ActionItemIcon = styled(Box, {
  shouldForwardProp: (prop) => !['bgcolor', 'svgdimensions'].includes(prop),
})(({ bgcolor, svgdimensions = {} }) => ({
  backgroundColor: bgcolor,
  minWidth: '48px',
  minHeight: '48px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 8,
  '& > svg': {
    ...svgdimensions,
  },
}));

export const GradientBackground = styled('div')({
  width: '48px',
  height: '48px',
  background: 'linear-gradient(210deg,#D9A6FF 13.4%,#F68084 86.6%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 8,
});
